import { createCtx } from './create-context.helper';
import { CompanyBranchViewModel } from '@lib/api-interface';

export const [useCompanyBranchContext, CompanyBranchContextProvider] = createCtx<CompanyBranchViewModel>();
